module.exports = __webpack_public_path__ + "img/Picture3.da19de75.png";